/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The current skill version's efficacy comparison using the server suggestion policy.
 */
export type SkillEfficacyRegressionSignal = {
  comparable: boolean;
  currentAverageScore: number;
  currentScoredSessions: number;
  currentVersionId: string;
  predecessorAverageScore: number;
  predecessorScoredSessions: number;
  predecessorVersionId?: string | undefined;
  regression: boolean;
  windowEnd: Date;
  windowStart: Date;
};

/** @internal */
export const SkillEfficacyRegressionSignal$inboundSchema: z.ZodMiniType<
  SkillEfficacyRegressionSignal,
  unknown
> = z.pipe(
  z.object({
    comparable: z.boolean(),
    current_average_score: z.number(),
    current_scored_sessions: z.int(),
    current_version_id: z.string(),
    predecessor_average_score: z.number(),
    predecessor_scored_sessions: z.int(),
    predecessor_version_id: z.optional(z.string()),
    regression: z.boolean(),
    window_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    window_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "current_average_score": "currentAverageScore",
      "current_scored_sessions": "currentScoredSessions",
      "current_version_id": "currentVersionId",
      "predecessor_average_score": "predecessorAverageScore",
      "predecessor_scored_sessions": "predecessorScoredSessions",
      "predecessor_version_id": "predecessorVersionId",
      "window_end": "windowEnd",
      "window_start": "windowStart",
    });
  }),
);

export function skillEfficacyRegressionSignalFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacyRegressionSignal, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacyRegressionSignal$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacyRegressionSignal' from JSON`,
  );
}
